import { customElement } from 'lit/decorators.js';
import { connect } from "pwa-helpers";
import store from "../../../store/store";
import { getFreightCalculationError, getFreightCalculationStatus } from "../shop-checkout";
import { ShippingMethodCheckoutStepBase } from "../shipping-method-checkout-step-base";
import { StoreState } from '../../../store/store.interface';
import { ActionStatus } from '../../../common/constants/action-status';
import { handleApiError } from '../../../common/utils/api-utils';

/**
 * Checkout Step to load shipping method options given shipping address. 
 * Save selected method in redux shop checkout state.
 */
@customElement('mhecomm-shipping-method-national-checkout-step')
export class ShippingMethodNationalCheckoutStep extends connect(store)(ShippingMethodCheckoutStepBase){

  stateChanged(state: StoreState) {
    this.canEditStep(state);

    this.handleApiFailures(state);
    this.isLoading = getFreightCalculationStatus(state) === ActionStatus.loading;
    if(getFreightCalculationStatus(state) === ActionStatus.succeeded) {
      this.onFreightCalculationResponse(state);
    }
  }

  override handleApiFailures(state: StoreState): void {
    if (getFreightCalculationStatus(state) === ActionStatus.failed) {
      handleApiError(getFreightCalculationError(state));
      return;
    } 
  }

}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-shipping-method-national-checkout-step': ShippingMethodNationalCheckoutStep;
  }
}

